import {Typography} from '@hconnect/uikit'
import {Box, Switch} from '@mui/material'
import React from 'react'
import {useTranslation} from 'react-i18next'
import {useDispatch, useSelector} from 'react-redux'

import {PageNames} from '../../../../common/constants'
import {AppState} from '../../../../Root.store'
import {filterType, useTrackFilterEvents} from '../../../../TrackEvents/hubFilterEvents'
import {
  removeOpenInvoicesFilter,
  selectOpenInvoicesFilter,
  setOpenInvoicesFilter
} from '../Invoice.filters'
import {InvoiceStatus} from '../Invoice.types'

export const OpenInvoicesFilter: React.FC<{onLight: boolean}> = ({onLight}) => {
  const {t} = useTranslation()
  const dispatch = useDispatch()
  const {trackFilterEvents} = useTrackFilterEvents()

  const includesOpenInvoices = useSelector<
    AppState,
    {status: keyof typeof InvoiceStatus} | undefined
  >((state) => selectOpenInvoicesFilter(state))

  const toggleOpenInvoicesFilter = (
    event: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ): void => {
    const filterEventData = {
      filterType: filterType.OPEN_INVOICES,
      page: PageNames.FINANCE_PAGE,
      checked,
      cleared: !checked
    }
    trackFilterEvents(filterEventData)

    checked
      ? dispatch(setOpenInvoicesFilter({status: [InvoiceStatus.open]}))
      : dispatch(removeOpenInvoicesFilter())
  }

  return (
    <Box display="flex" pl={1} mr={1} alignItems="center" gap={2}>
      <Switch
        data-test-id="invoices-open-filter"
        aria-label="Open invoice filter"
        size="medium"
        checked={includesOpenInvoices && includesOpenInvoices.status.includes(InvoiceStatus.open)}
        onChange={toggleOpenInvoicesFilter}
      />
      <Typography variant="body1" color={onLight ? 'textPrimary' : 'textSecondary'}>
        {t('invoice.openInvoicesFilterLabel')}
      </Typography>
    </Box>
  )
}
